import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';

import withStyles from '../../decorators/withStyles';
import { abbreviate, formatZillowValue, togglePanel } from "../../utils/utils";
import styles from './ZillowRanking.css';


class ZillowRanking extends Component {

  static propTypes = {
    placeList: PropTypes.array.isRequired,
    zillowIsPct: PropTypes.bool.isRequired,
    zillowVarType: PropTypes.string.isRequired,
  };

  navigateTo = (path) => {
    window.scrollTo(0, 0);
    browserHistory.push({pathname: `/${path}`});
  };

  render() {
    const { placeList, zillowIsPct, zillowVarType } = this.props;
    const formatValue = (value) => formatZillowValue(value, zillowVarType, zillowIsPct);

    return (
      <div className="ZillowRanking">
        <div className="collapsible-panel">
          <h4 className="panel-tab" onClick={togglePanel}>Top threats on map</h4>
          <div className="panel-content">
            <div className="panel-content-container">
              <table>
                <tbody>
                {placeList.map((place) => {
                  return (
                    <tr key={place.name} onClick={this.navigateTo.bind(this, place.path)}>
                      <td>{abbreviate(place.name)}</td>
                      <td className="value" dangerouslySetInnerHTML={{__html: `<var>${formatValue(place.value)}</var>`}} />
                    </tr>
                  );})}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ZillowRanking);
